/**
 * Dasboard data class
 */
import i18n, { reloadResources } from 'i18next'
import { DataAttributeDefinitions, load, provideDataClass } from 'scrivito'

import { DataClassName } from '../const'
import { DASHBAORD_ELEMENTS_ENDPOINT } from '@/Data/const'
import { getInstanceIdFromUrl } from '@/utils/getInstanceIdFromUrl'

/**
 * chart type enumeration
 */
export enum PisaSalesChartType {
  Marketing = 'marketing',
  Sales = 'sales',
  Service = 'service',
}

/**
 * chart style enumeration
 */
export enum PisaSalesChartStyle {
  Diagram = 'diagram',
  List = 'list',
}

/**
 * Dashboard chart configuration
 */
export interface ChartConfig {
  element: string
  title: string
  group: string
  type: PisaSalesChartType
  style: PisaSalesChartStyle
}

/**
 * Dashboard configuration type
 */
export type DashboardConfig = ChartConfig[] | null

/**
 * attribute definitions
 */
const DASHBOARD_ATTR: DataAttributeDefinitions = {
  element: 'string',
  title: 'string',
  group: 'string',
  type: 'string',
  style: 'string',
}

/**
 * provides the REST endpoint descriptor
 * @returns the REST endpoint descriptor
 */
const restAPI = async () => {
  await load(() => reloadResources())

  const pisaUrl = `https://api.justrelate.com/neocrm/instance/${getInstanceIdFromUrl()}`
  return {
    url: `${pisaUrl}/${DASHBAORD_ELEMENTS_ENDPOINT}`,
    authViaInstance: getInstanceIdFromUrl(),
    headers: { 'Accept-Language': i18n?.resolvedLanguage || 'en' },
  }
}

/**
 * provide Dashboard data class
 */
export const DashboardClass = provideDataClass(DataClassName.DASHBOARD, {
  title: DataClassName.DASHBOARD,
  restApi: restAPI(),
  attributes: DASHBOARD_ATTR,
})
